import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

import DataGrid from "../../components/DataGrid";

import AdminModule from "../../components/boxes/AdminModule";
// import { adminPages } from "../../variables/adminPages";
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import FramesWidget from "../widgets/FramesWidget";
import Responsive from "../Responsive";
import { SubTitle } from "chart.js";
// import Header from "../header/Header";


class DashboardView extends React.Component {


    state = {
        // modules: [],
    }
    handleBackAction = (features) => {
        if (features.includes('Messenger')) {
            this.props.changeMessengerStage('main')
        } else if (features.includes('Drive')) {
            this.props.changePage(null, null, true)
        }
    }
    componentDidMount() {
        if (this.props.setHeader) {
            // console.log(this.props.applet)
            let obj = {
                'toolbar': null,
                'showToolbar': (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? false : true,
                backAction: (this.props.applet && this.props.applet.features && this.props.isPortal && ['Messenger', 'Drive'].includes(this.props.applet.features[0])) ? (() => { this.handleBackAction(this.props.applet.features) }) : false,
                title: translate("Dashboard"),
                toolbarPadding: 10,
                subtitle: `${checkTranslation(this.props.applet?.name)} / ${checkTranslation(this.props.applet?.hub?.fullname)}`

            }
            if (this.props.defaultHeaderConfig) {
                obj = this.props.defaultHeaderConfig
            }
            this.props.setHeader(obj)
        }
        // this.props.setHeader('showToolbar', false)
    }
    componentDidUpdate(prevProps) {
        // if (JSON.stringify(this.props.modules) != JSON.stringify(prevProps.modules)) {
        // }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'DashboardView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    render() {
        let modules = JSON.parse(JSON.stringify(this.props.modules))
        if (modules) {
            modules = modules.filter(m => { return (!m.hideInDashboard && !m.userperspective) })
            // modules = modules.filter(m => { return (m?.mode != 'relevant') })
        }
        return (
            <div className="h-100  w-100  scroll-no-scrollbar px-4 py-4">
                <div className="d-flex flex-wrap w-100">
                    <Responsive className={'d-flex prd-5 '} width={this.props.width} media={{ xs: "12", sm: '12', md: '12', lg: "3", xl: "3" }}>
                        <div className="w-100 br-8" style={{ boxShadow: '0px 0px 20px #10101020' }}>
                            <FramesWidget modules={modules} onClick={this.props.onClick} changePage={this.props.changePage} variables={this.props.variables} width={this.props.width} height={this.props.height} page={this.props.page} />
                        </div>
                        {/* <DataGrid setData={this.setData} isLoading={this.state.isLoading} onClick={this.props.onClick} functionsHandler={this.props.functionsHandler} width={this.props.width} data={modules} component={AdminModule} col={{ xs: "12", sm: '6', md: '4', lg: "3", xl: "2" }} settings={{ baseUrl: this.props.baseUrl, changePage: this.props.changePage }} permissionLevel={this.props.permissionLevel} permissions={this.props.permissions} /> */}
                    </Responsive>
                </div>
            </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardView);
